import React from 'react';
import PropTypes from 'prop-types';

import { App } from '@meronex/app';

import { ActionBtn, CloseBtn, toast } from '@meronex/components';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { useTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';

import StoreCategoryForm from './StoreCategoryForm';
import { storeCategoriesMng } from '../api/storeCategoriesMng';

const useStyles = makeStyles((theme) => ({
  container: {},
}));

function EditStoreCategoryDialog(props) {
  const classes = useStyles();
  const theme = useTheme();

  const { open, onClose, onEdit, storeCategory } = props;

  const [loading, setLoading] = React.useState(false);
  const [formData, setFormData] = React.useState({ isValid: true });

  React.useEffect(() => {
    setFormData({ ...storeCategory });
  }, [storeCategory]);

  const _onClose = () => {
    onClose();
  };

  const editStoreCategory = async () => {
    console.log('on edit');
    console.log(storeCategory);

    setLoading(true);

    const _updatedStoreCategory = Object.assign(storeCategory, formData);
    delete _updatedStoreCategory.isValid;

    try {
      await storeCategoriesMng.updateStoreCategory(_updatedStoreCategory);
      onEdit();
      onClose();
      toast.success('Store category updated', {
        autoClose: 900,
      });
    } catch (e) {
      toast.error('Ops, something went wrong');
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  if (!storeCategory || !open) {
    return null;
  }
  return (
    <Dialog className={'fullScreenMobile'} open={open} onClose={onClose}>
      <DialogTitle>
        Edit Store Category
        <CloseBtn onClick={_onClose} />
      </DialogTitle>
      <DialogContent>
        <StoreCategoryForm
          validateOnInit={true}
          onChange={(values) => {
            console.log(values);
            setFormData({ ...Object.assign(formData, values) });
          }}
          values={formData}
        />
        <div
          style={{
            marginBottom: '20px',
            marginTop: '20px',
            textAlign: 'center',
          }}>
          <ActionBtn
            loading={loading}
            disabled={loading || (formData && !formData.isValid)}
            label={<span>Save Store Category</span>}
            onClick={editStoreCategory}
            onEnter={editStoreCategory}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

EditStoreCategoryDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  editStoreCategory: PropTypes.func,
  storeCategory: PropTypes.object,
  onEdit: PropTypes.func,
};

EditStoreCategoryDialog.defaultProps = {
  open: false,
  onClose: () => {},
  storeCategory: {},
};

export default EditStoreCategoryDialog;
